import {
    AppBar,
    Avatar,
    Box,
    Button,
    Icon,
    Tab,
    Tabs,
    Toolbar,
    Tooltip,
    Typography,
} from '@material-ui/core';
import React from 'react';
import moment from 'moment-timezone';
import { makeStyles } from '@material-ui/core/styles';
import './styles.scss';
import { withRouter } from 'react-router-dom';
import routes from '../../routes';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { connect } from 'react-redux';
import SwitchHubModal from '../Modals/SwitchHub';
import { canAllow, getPermissions } from '../../utils/helper';
import {
    BBNOW_VENDOR_ID,
    isBlueDartOrg,
    isBlueDartUser,
    isBdUserManagementTabEnabled,
    isBdApprovalWorkflowEnabled,
} from '../../utils/appHelper';
import AdminUserModal from '../Modals/AdminUserModal';
import bluerDartLogo from '../../assets/images/Blue_Dart_logo_transparent.png';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

const useStyles = makeStyles((theme) => ({
    main: {
        color: theme.palette.background.default,
        backgroundColor: theme.palette.primary.main,
        fontSize: '32px',
    },
    settings: {
        backgroundColor: 'white',
        color: theme.palette.primary.main,
        textTransform: 'none',
        border: '1px solid',
        borderColor: 'rgba(67,65,158,.24)',
        '&:hover': {
            backgroundColor: 'rgba(67,65,158,.1) !important',
            color: theme.palette.primary.main,
        },
    },
    settings2: {
        backgroundColor: 'white',
        color: theme.palette.primary.main,
        textTransform: 'none',
        border: '1px solid',
        borderColor: 'rgba(67,65,158,.24)',
        '&:hover': {
            backgroundColor: 'rgba(67,65,158,.1) !important',
            color: theme.palette.primary.main,
        },
        minWidth: 110,
        height: 40,
        borderRadius: 10,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        boxShadow: '0 1px 2px rgba(67,65,158,.06)',
    },
    createUser: {
        textTransform: 'none',
        whiteSpace: 'nowrap',
        minWidth: 100,
        height: 40,
        borderRadius: 10,
        fontWeight: 600,
        padding: '6px 20px',
    },
    tab: {
        textTransform: 'none',
        fontWeight: 600,
        fontSize: 15,
        letterSpacing: 0,
        minHeight: 64,
        minWidth: 'auto',
        padding: '0 20px',
        color: theme.palette.text.secondary,
        opacity: 1,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    },
    activeSettings: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        textTransform: 'none',
    },
    nav: {
        flexGrow: 1,
        alignSelf: 'stretch',
        marginTop: '10px',
        textTransform: 'none',
    },
    navLink: {
        color: theme.palette.text.secondary,
        textAlign: 'center',
        cursor: 'pointer',
        alignItems: 'center',
        justifyItems: 'center',
    },
    activeNav: {
        color: theme.palette.primary.main,
        borderBottom: `3px ${theme.palette.primary.main} solid`,
    },
    orgCluster: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 6,
    },
    orgSelector: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        maxWidth: 240,
        padding: '4px 4px',
        borderRadius: 8,
        color: theme.palette.primary.main,
        fontSize: 17,
        fontWeight: 700,
        lineHeight: 1.2,
    },
    orgSelectorClickable: {
        cursor: 'pointer',
        // border: '1px solid rgba(67,65,158,.18)',
        transition: 'background-color .15s ease',
        '&:hover': {
            backgroundColor: 'rgba(67,65,158,.08)',
        },
    },
}));

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

function TimezoneClock({ timezone }) {
    const [now, setNow] = React.useState(() => moment().tz(timezone));

    React.useEffect(() => {
        setNow(moment().tz(timezone));
        const id = setInterval(() => setNow(moment().tz(timezone)), 1000);
        return () => clearInterval(id);
    }, [timezone]);

    if (!timezone) return null;

    const time = now.format('hh:mm:ss A');
    const offset = now.format('Z'); // e.g. +05:30
    const rawAbbr = now.format('z'); // e.g. IST (or numeric offset for some zones)
    const abbr = /^[A-Za-z]+$/.test(rawAbbr) ? rawAbbr : `UTC${offset}`;

    const Separator = () => (
        <span style={{ color: 'rgba(67,65,158,.35)' }}>|</span>
    );

    return (
        <Tooltip
            title={`UTC${offset} · ${now.format('ddd, DD MMM YYYY')}`}
            arrow
        >
            <Box
                display="flex"
                alignItems="center"
                style={{
                    gap: 8,
                    padding: '4px 4px',
                    borderRadius: 8,
                    //backgroundColor: 'rgba(67,65,158,.08)',
                    //border: '1px solid rgba(67,65,158,.16)',
                    cursor: 'default',
                    whiteSpace: 'nowrap',
                }}
            >
                <AccessTimeIcon style={{ fontSize: 18, color: '#43419e' }} />
                <Typography
                    style={{
                        color: '#43419e',
                        fontSize: 13,
                        fontWeight: 700,
                    }}
                >
                    {timezone}
                </Typography>
                <Separator />
                <Typography
                    style={{
                        color: '#43419e',
                        fontSize: 13,
                        fontWeight: 700,
                        fontVariantNumeric: 'tabular-nums',
                    }}
                >
                    {time}
                </Typography>
                {/* <Separator />
                <Typography
                    style={{
                        color: '#7a79b3',
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    {abbr}
                </Typography> */}
            </Box>
        </Tooltip>
    );
}

function Navbar({ orgInfo, user, isBBNowVendor, timezone, ...props }) {
    const classes = useStyles();
    const [value, setValue] = React.useState(
        routes.find((r) => props.location.pathname.includes(r.path)).path,
    );
    const [isSwitchHubModalOpen, setisSwitchHubModalOpen] =
        React.useState(false);
    const [isAdminUserModalOpen, setIsAdminUserModalOpen] =
        React.useState(false);
    const handleChange = (event, path) => {
        setValue(path);
        props.history.push(path);
    };

    const isZappayUser =
        !getPermissions('staff')?.read &&
        !getPermissions('attendance')?.read &&
        !getPermissions('map_view')?.read &&
        !getPermissions('report')?.read &&
        !isBBNowVendor;
    const isBD_USER = isBlueDartUser?.();
    const isNonIndiaOrg =
        !!user?.config?.country &&
        user.config.country.trim().toLowerCase() !== 'india';
    const accessManagementPermission = getPermissions('access_management');

    // The User Management tab replaces this button for Blue Dart: it is the only path that can
    // assign scope, and this one opens the same modal with no store/zone options at all. Hidden
    // rather than fixed, so there is one way to create an internal user. Every other org keeps it.
    const bdUserManagementSupersedes =
        isBlueDartOrg?.() && isBdUserManagementTabEnabled();

    // console.log('accessManagementPermission', accessManagementPermission);
    const ORG_NAME = localStorage.getItem('org') ?? orgInfo?.name ?? 'Guest';
    let OrgName = ORG_NAME;

    OrgName = OrgName?.length > 15 ? OrgName?.slice(0, 15) + '...' : OrgName;
    const isMultiOrgUser = user?.config?.isMultiOrgUser == 'true';
    return (
        <div className="appbar" style={{ marginBottom: 80 }}>
            <AppBar
                color="default"
                position="fixed"
                style={{
                    padding: '0px 48px',
                    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
                    backgroundColor: '#fff',
                }}
            >
                <Toolbar disableGutters={true}>
                    {/* <Avatar className={classes.main}>.</Avatar> */}
                    <Box
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                        justifyContent={'flex-start'}
                        style={{
                            width:
                                !!isBD_USER || isBlueDartOrg?.()
                                    ? '18%'
                                    : '10%',
                        }}
                    >
                        {(isBD_USER || isBlueDartOrg?.()) && (
                            <img
                                src={bluerDartLogo}
                                style={{
                                    width: '225px',
                                    height: '52px',
                                    marginLeft: '8px',
                                    marginRight: '8px',
                                }}
                                alt="isBD_USER"
                            />
                        )}
                        {!isBD_USER && !isBlueDartOrg?.() && (
                            <Button
                                variant="contained"
                                color="default"
                                className={`${classes.settings} ${
                                    props.location.pathname.includes(
                                        '/settings',
                                    ) && classes.activeSettings
                                }`}
                                startIcon={<Icon>settings</Icon>}
                                onClick={(e) => props.history.push('/settings')}
                                disabled={!getPermissions('settings')?.read}
                                disableElevation
                            >
                                Settings
                            </Button>
                        )}
                    </Box>

                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="on"
                        indicatorColor="primary"
                        textColor="primary"
                        aria-label="scrollable force tabs example"
                        className={classes.nav}
                    >
                        {routes
                            .filter((nav) => nav.keepInNav)
                            .sort((a, b) => a.order - b.order)
                            .map((nav, index) => {
                                const isAgencyVendor =
                                    user?.role === 40 || user?.role === '40';
                                const isEvSpUser =
                                    !!getPermissions('EV SP')?.read;
                                const isEvCmUser =
                                    !!getPermissions('EV CM')?.read &&
                                    !isEvSpUser;
                                // const hiddenForCm =
                                //     isEvCmUser && nav?.name !== 'EV CM';
                                const hiddenForSp =
                                    isEvSpUser && nav?.name === 'EV CM';
                                const hiddenForNonIndia =
                                    nav?.name === 'QC Leads' && isNonIndiaOrg;
                                // Blue Dart User Management: gated on the rollout flag AND the
                                // screen permission, the same pairing the Capacity Approvals tab
                                // uses. Permission alone would show a working-looking tab for a
                                // feature that is not live yet; the flag alone would show it to
                                // roles the backend refuses.

                                // One tab for both BGV screens: shown when either is readable.
                                const hasBgvAccess =
                                    !!getPermissions('BGV TRACKING')?.read ||
                                    !!getPermissions('BGV BACKFILLING')?.read;
                                // Blue Dart User Management: gated on the rollout flag AND the
                                // screen permission, the same pairing the Capacity Approvals tab
                                // uses. Permission alone would show a working-looking tab for a
                                // feature that is not live yet; the flag alone would show it to
                                // roles the backend refuses (UM-1 returns 403 for them).
                                const hiddenUserManagement =
                                    nav?.name === 'User Management' &&
                                    !isBdUserManagementTabEnabled();
                                const hiddenApprovalWorkflow =
                                    nav?.name === 'Approval Workflow' &&
                                    !isBdApprovalWorkflowEnabled();
                                const hasPermission =
                                    // hiddenForCm ||
                                    hiddenForSp ||
                                    hiddenForNonIndia ||
                                    hiddenUserManagement ||
                                    hiddenApprovalWorkflow
                                        ? false
                                        : nav?.name === 'Remittance'
                                          ? !!isBD_USER
                                              ? false
                                              : isZappayUser &&
                                                !getPermissions('agency_hire')
                                                    ?.read
                                          : nav?.name === 'Agency Staffs'
                                            ? isAgencyVendor
                                            : nav?.name === 'Agency'
                                              ? isAgencyVendor
                                              : nav?.name === 'Referral Report'
                                                ? isAgencyVendor
                                                : nav?.name === 'AMZ Rerun'
                                                  ? !!user?.config?.enableRerun
                                                  : nav?.name === 'BGV Tracking'
                                                    ? hasBgvAccess
                                                    : getPermissions(nav?.name)
                                                          ?.read;
                                return (
                                    hasPermission && (
                                        <Tab
                                            key={index}
                                            className={classes.tab}
                                            label={
                                                !!nav?.routeName
                                                    ? nav?.routeName
                                                    : nav?.name
                                            }
                                            value={nav.path}
                                            disabled={
                                                nav?.name === 'BGV Tracking'
                                                    ? !hasBgvAccess
                                                    : !getPermissions(nav.name)
                                                          ?.read
                                            }
                                            {...a11yProps(index)}
                                        />
                                    )
                                );
                            })}
                    </Tabs>
                    {/* <Grid
                        container
                        direction="row"
                        justify="center"
                        alignItems="stretch"
                        spacing={5}
                        className={classes.nav}
                    >
                        {
                            routes.filter(nav => nav.keepInNav).sort((a,b) => a.order - b.order).map(nav => {
                                return <Grid
                                    key={nav.name}
                                    onClick={e => props.history.push(nav.path)}
                                    className={`${classes.navLink} ${props.location.pathname === nav.path && classes.activeNav}`}
                                    item
                                    lg={1}
                                    xs={12}
                                >
                                    {nav.name}
                                </Grid>
                            })
                        }
                    </Grid> */}

                    <Box
                        style={{
                            width:
                                !!isBD_USER || !!isBlueDartOrg?.()
                                    ? '28%'
                                    : !!timezone
                                      ? '21%'
                                      : '15%',
                            gap: 12,
                        }}
                        display={'flex'}
                        flexDirection={'row'}
                        justifyContent={'flex-end'}
                        alignItems={'center'}
                    >
                        {!!accessManagementPermission.create &&
                            !bdUserManagementSupersedes && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className={classes.createUser}
                                    onClick={() => {
                                        setIsAdminUserModalOpen(true);
                                    }}
                                    disabled={
                                        !accessManagementPermission.create
                                    }
                                    disableElevation
                                >
                                    Create User
                                </Button>
                            )}

                        {(!!isBD_USER || isBlueDartOrg?.()) && (
                            <Button
                                variant="contained"
                                color="default"
                                className={`${classes.settings2} ${
                                    props.location.pathname.includes(
                                        '/settings',
                                    ) && classes.activeSettings
                                }`}
                                startIcon={<Icon>settings</Icon>}
                                onClick={(e) => props.history.push('/settings')}
                                disabled={!getPermissions('settings')?.read}
                                disableElevation
                            >
                                Settings
                            </Button>
                        )}
                        <Box className={classes.orgCluster}>
                            {!isBD_USER &&
                                !getPermissions('agency_hire')?.read && (
                                    <Box
                                        className={`${classes.orgSelector} ${
                                            isMultiOrgUser
                                                ? classes.orgSelectorClickable
                                                : ''
                                        }`}
                                        title={ORG_NAME}
                                        onClick={() => {
                                            if (isMultiOrgUser) {
                                                setisSwitchHubModalOpen(true);
                                            }
                                        }}
                                    >
                                        <Typography
                                            noWrap
                                            style={{
                                                color: 'inherit',
                                                fontSize: 'inherit',
                                                fontWeight: 'inherit',
                                            }}
                                        >
                                            {OrgName}
                                        </Typography>
                                        {isMultiOrgUser && (
                                            <ExpandMoreIcon
                                                style={{ fontSize: 20 }}
                                            />
                                        )}
                                    </Box>
                                )}
                            {timezone && <TimezoneClock timezone={timezone} />}
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>

            {isSwitchHubModalOpen && (
                <SwitchHubModal
                    open={isSwitchHubModalOpen}
                    onClose={() => {
                        setisSwitchHubModalOpen(false);
                    }}
                    {...props}
                />
            )}

            {isAdminUserModalOpen && (
                <AdminUserModal
                    open={isAdminUserModalOpen}
                    mode="create"
                    onClose={() => setIsAdminUserModalOpen(false)}
                />
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    orgInfo: state.settings.basicDetails,
    user: state.user,
    isBBNowVendor: BBNOW_VENDOR_ID?.includes(state?.user?.role) ?? false,
    timezone: state?.user?.config?.timezone,
});

export default withRouter(connect(mapStateToProps, null)(Navbar));
